import { render, staticRenderFns } from "./RequestEmailConfirmation.vue?vue&type=template&id=22f982e8&"
import script from "./RequestEmailConfirmation.vue?vue&type=script&lang=js&"
export * from "./RequestEmailConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./RequestEmailConfirmation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports